import Iphone15Pro from "../@/components/ui/iphone-15-pro";
import t1 from "../assets/t1.png";
import t2 from "../assets/t2.png";
import t3 from "../assets/t3.png";
import t4 from "../assets/t4.png";
import t5 from "../assets/t5.png";
import t6 from "../assets/t6.png";
import t7 from "../assets/t7.png";
import t8 from "../assets/t8.png";
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

type Template = {
  id: number;
  image: string;
  name: string;
  description: string;
  ctaUrl: string;
};

export function Templates() {
  const { t } = useTranslation();
  
  const translations = t('templates', { returnObjects: true }) as {
    title: string;
    subtitle: string;
    templates: Template[];
    cta: string;
  };

  // Image mapping with all template images
  const imageMap: Record<string, string> = {
    't1.png': t1,
    't2.png': t2,
    't3.png': t3,
    't4.png': t4,
    't5.png': t5,
    't6.png': t6,
    't7.png': t7,
    't8.png': t8,
  };

  // URL mapping for each template
  const urlMap: Record<number, string> = {
    1: "https://my.spotcard.in/",
    2: "https://my.spotcard.in/t2",
    3: "https://my.spotcard.in/t3",
    4: "https://my.spotcard.in/t4",
    5: "https://my.spotcard.in/t5",
    6: "https://my.spotcard.in/t6",
    7: "https://my.spotcard.in/t7",
    8: "https://my.spotcard.in/t8",
  };

  return (
    <section id="templates" className="text-center md:container relative bg-white-bg rounded text-black mt-10">
      <div className="p-10">
        <h1 className="text-4xl text-black font-primary font-bold p-5">
          {translations.title}
        </h1>
        <h2 className="text-2xl font-secondary text-black dark:text-white">
          {translations.subtitle}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-8 mt-8">
          {translations.templates.map((template) => (
            <div key={template.id} className="flex flex-col items-center">
              {/* Accessibility container */}
              <div aria-label={template.name}>
                <Iphone15Pro
                  className="max-w-[230px] h-[480px] mx-auto"
                  src={imageMap[template.image]}
                />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-black dark:text-white">
                {template.name}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-300">
                {template.description}
              </p>
              <a 
                href={urlMap[template.id]} 
                target="_blank" 
                rel="noopener noreferrer"
                className="boton-elegante mt-4"
              >
                {translations.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}